import axios from '@/plugins/axios'

export function getDepositCard(params = {}) {
  return axios.get('deposit_cards', { params })
}

export function storeDepositCard(data) {
  return axios.post('deposit_cards', data)
}

export function destroyDepositCard(id) {
  return axios.delete(`deposit_cards/${id}`)
}

export function updateDepositCard(id, data) {
  return axios.put(`deposit_cards/${id}`, data)
}

export function editDepositCard(id) {
  return axios.get(`deposit_cards/${id}/edit`)
}

export function giveDepositCardToUser(data) {
  return axios.post('deposit_cards/giveDepositCardToUser', data)
}

export function getDepositCardOrders(params = {}) {
  return axios.get('deposit_card_orders', { params })
}
